/**
 * @fileoverview gRPC-Web generated client stub for acompanha.commerce_partners.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/commerce_partners/v1/commerce_partners.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.commerce_partners = {};
proto.acompanha.commerce_partners.v1 = require('./commerce_partners_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest,
 *   !proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse>}
 */
const methodDescriptor_CommercePartnersService_ListCommercePartners = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartners',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest,
  proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.listCommercePartners =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartners',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_ListCommercePartners,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.ListCommercePartnersResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.listCommercePartners =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartners',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_ListCommercePartners);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest,
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse>}
 */
const methodDescriptor_CommercePartnersService_GetCommercePartner = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartner',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest,
  proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.getCommercePartner =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartner,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.GetCommercePartnerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.getCommercePartner =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartner);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest,
 *   !proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse>}
 */
const methodDescriptor_CommercePartnersService_CreateCommercePartner = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartner',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest,
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.createCommercePartner =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CreateCommercePartner,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.CreateCommercePartnerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.createCommercePartner =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CreateCommercePartner);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest,
 *   !proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse>}
 */
const methodDescriptor_CommercePartnersService_UpdateCommercePartner = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/UpdateCommercePartner',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest,
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.updateCommercePartner =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/UpdateCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_UpdateCommercePartner,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.UpdateCommercePartnerResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.updateCommercePartner =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/UpdateCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_UpdateCommercePartner);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_CommercePartnersService_DeleteCommercePartner = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartner',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.deleteCommercePartner =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeleteCommercePartner,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.deleteCommercePartner =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartner',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeleteCommercePartner);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest,
 *   !proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse>}
 */
const methodDescriptor_CommercePartnersService_DeliverCommercePartnerStock = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/DeliverCommercePartnerStock',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest,
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.deliverCommercePartnerStock =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeliverCommercePartnerStock',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeliverCommercePartnerStock,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.DeliverCommercePartnerStockResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.deliverCommercePartnerStock =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeliverCommercePartnerStock',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeliverCommercePartnerStock);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest,
 *   !proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse>}
 */
const methodDescriptor_CommercePartnersService_CreateCommercePartnerOrder = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartnerOrder',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest,
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.createCommercePartnerOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartnerOrder',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CreateCommercePartnerOrder,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.CreateCommercePartnerOrderResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.createCommercePartnerOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CreateCommercePartnerOrder',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CreateCommercePartnerOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest,
 *   !proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse>}
 */
const methodDescriptor_CommercePartnersService_RegenerateCommercePartnerSchedule = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/RegenerateCommercePartnerSchedule',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest,
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.regenerateCommercePartnerSchedule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/RegenerateCommercePartnerSchedule',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_RegenerateCommercePartnerSchedule,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.RegenerateCommercePartnerScheduleResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.regenerateCommercePartnerSchedule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/RegenerateCommercePartnerSchedule',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_RegenerateCommercePartnerSchedule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest,
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse>}
 */
const methodDescriptor_CommercePartnersService_GetCommercePartnersDashboard = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersDashboard',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest,
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.getCommercePartnersDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersDashboard',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnersDashboard,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.GetCommercePartnersDashboardResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.getCommercePartnersDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersDashboard',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnersDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest,
 *   !proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse>}
 */
const methodDescriptor_CommercePartnersService_ListCommercePartnerVisits = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartnerVisits',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest,
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.listCommercePartnerVisits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartnerVisits',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_ListCommercePartnerVisits,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.ListCommercePartnerVisitsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.listCommercePartnerVisits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/ListCommercePartnerVisits',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_ListCommercePartnerVisits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest,
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse>}
 */
const methodDescriptor_CommercePartnersService_GetCommercePartnersMap = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersMap',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest,
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.getCommercePartnersMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersMap',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnersMap,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.GetCommercePartnersMapResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.getCommercePartnersMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnersMap',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnersMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest,
 *   !proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse>}
 */
const methodDescriptor_CommercePartnersService_GetCommercePartnerVisit = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnerVisit',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest,
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.getCommercePartnerVisit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnerVisit,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.GetCommercePartnerVisitResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.getCommercePartnerVisit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/GetCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_GetCommercePartnerVisit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest,
 *   !proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse>}
 */
const methodDescriptor_CommercePartnersService_CompleteCommercePartnerVisit = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/CompleteCommercePartnerVisit',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest,
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.completeCommercePartnerVisit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CompleteCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CompleteCommercePartnerVisit,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.CompleteCommercePartnerVisitResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.completeCommercePartnerVisit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/CompleteCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_CompleteCommercePartnerVisit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest,
 *   !proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse>}
 */
const methodDescriptor_CommercePartnersService_MarkCommercePartnerVisitPaid = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/MarkCommercePartnerVisitPaid',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest,
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.markCommercePartnerVisitPaid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/MarkCommercePartnerVisitPaid',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_MarkCommercePartnerVisitPaid,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.commerce_partners.v1.MarkCommercePartnerVisitPaidResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.markCommercePartnerVisitPaid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/MarkCommercePartnerVisitPaid',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_MarkCommercePartnerVisitPaid);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_CommercePartnersService_DeleteCommercePartnerVisit = new grpc.web.MethodDescriptor(
  '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartnerVisit',
  grpc.web.MethodType.UNARY,
  proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServiceClient.prototype.deleteCommercePartnerVisit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeleteCommercePartnerVisit,
      callback);
};


/**
 * @param {!proto.acompanha.commerce_partners.v1.DeleteCommercePartnerVisitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.commerce_partners.v1.CommercePartnersServicePromiseClient.prototype.deleteCommercePartnerVisit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.commerce_partners.v1.CommercePartnersService/DeleteCommercePartnerVisit',
      request,
      metadata || {},
      methodDescriptor_CommercePartnersService_DeleteCommercePartnerVisit);
};


module.exports = proto.acompanha.commerce_partners.v1;

